<template>
    <div v-loading="loadingInv">
        <div class="page-invoice scrollable">
            <div v-if="!showAlert">
                <!-- <iframe 
                    :src="srcPdf" id="myFrame" 
                        frameborder="0" style="border:0;" 
                            width="300" height="300">
                </iframe> -->
                <el-tabs v-model="tabs" type="border-card" @tab-click="tabClick">
                    <el-tab-pane label="Report" name="report">
                        <el-row>
                            <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
                                <div>
                                    <h1>Report Billing</h1>
                                </div>
                                <div>
                                    <el-select v-model="selectedMonth" placeholder="Select Month" style="float:left; margin: 5px 10px 5px 0;">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-button type="info" @click="getBilling" style="float:left; margin: 5px 0 5px 0;" :loading="btnLoadingDownload" round>Search</el-button>
                                    
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
                                <el-button style="float:right; margin-right: 2em; margin-top: 90px; background-color: #7E7BF2; color: #FFFFFF; padding-left: 30px; padding-right:30px;" @click="getBilling('download')" :loading="loadingPrint" round ><b>Download Excel</b></el-button>
                                <!-- <el-button style="margin-right: 3em; margin-top: 90px; background-color: #7E7BF2; color: #FFFFFF; padding-left: 30px; padding-right:30px;" @click="getBilling('download')" :loading="loadingPrint" round ><b>Download Excel</b></el-button> -->
                                <!-- <el-button class="animated fadeInRight" style="margin: 5px 0 5px 0;" plain @click="getBilling('download')"><i class="mdi mdi-download" /> Download</el-button> -->
                            </el-col>
                        </el-row>
                        <div id="html-2-pdfwrapper">
                            <el-row>
                                <el-col>
                                    <div style="padding: 40px 0 30px 0;" class="invoice-top">
                                        <div style="display: inline-block;" class="logo">
                                            <img style="max-width: 70px; max-height: 50px;" src="@/assets/images/logo-cropped.png" alt="logo">
                                        </div>
                                        <div style="display: inline-block;" class="info">
                                            <h3 style="margin: 0 0 0 10px;">DAM Corp.</h3>
                                            <p style="font-size: 12px; margin: 0 0 0 10px;">daisy@damcorp.id<br>(021) 30487010</p>
                                        </div><!--End Info-->
                                    </div><!--End InvoiceTop-->
                                </el-col>
                            </el-row>
                            <el-row style="padding: 20px 0 20px 0;" v-if="!showAlert">
                                <el-col>
                                    <el-row>
                                        <el-col>
                                            <el-table
                                                :data="table"
                                                :cell-class-name="`cell-custom`"
                                                style="width: 100%; text-align: left;">
                                                <el-table-column
                                                label="Service Name"
                                                width="380"
                                                fixed="left">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="24">
                                                                <div v-if="scope.row.additional_billing" class="wa-number"><b>{{scope.row.list}}.</b> Additional Billing</div>
                                                                <div v-else-if="scope.row.omni_billing" class="wa-number"><b>{{scope.row.list}}.</b> Additional Service</div>
                                                                <div v-else class="wa-number"><b>{{scope.row.list}}.</b> Whatsapp Business ({{scope.row.customerNumber}})</div>
                                                            </el-col>
                                                            <span v-if="scope.row.additional_billing">
                                                                <el-col v-for="(item,k) in  scope.row.productName" :key="k" class="pd-item" :span="24"><span >{{scope.row.list}}-{{Number(k) + 1}}. {{scope.row.productName[`${k}`]}} ({{scope.row.productType[`${k}`].replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}})</span></el-col>
                                                            </span>
                                                            <span v-else-if="scope.row.omni_billing">
                                                                <el-col v-for="(item,i) in  scope.row.productName" :key="i" class="pd-item" :span="24"><div >{{scope.row.list}}-{{Number(i) + 1}}. {{scope.row.productName[`${i}`]}} ({{scope.row.productType[`${i}`].replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}})</div>
                                                                <div >Service Fee ({{scope.row.serviceFeeType[`${i}`] ? scope.row.serviceFeeType[`${i}`].replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()):''}})</div>
                                                                </el-col>
                                                            </span>
                                                            <el-col v-else class="pd-item" :span="24"><span >{{scope.row.productName}} ({{scope.row.productType}})</span></el-col>
                                                            <span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName != 'Maintenance'">
                                                                <el-col class="pd-item" :span="24"><span >National</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style=" visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style=" visibility: hidden;"></span></el-col>
                                                            </span>
                                                            <el-col v-if="scope.row.international_billing && scope.row.international_billing.length > 0" class="pd-item" style="padding-top: 120px; margin-bottom:10px;" :span="24"><span >International</span>
                                                                <el-row v-for="(data, i) in scope.row.international_billing" :key="i">
                                                                    <el-col style="margin-top: 10px;">
                                                                        <span style="margin-left: 30px;">+{{data.country_code}}</span>
                                                                    </el-col>
                                                                    <el-col >
                                                                        <span style="margin-left: 30px; visibilty: hidden;"></span>
                                                                    </el-col>
                                                                </el-row>
                                                            </el-col>
                                                            <el-col v-else-if="scope.row.omni_billing" :style="{'padding-top': '18px'}"><span ></span></el-col>
                                                            <el-col v-else-if="scope.row.additional_billing" :style="{'padding-top': '20px'}"><span ></span></el-col>
                                                            <el-col v-else :style="{'padding-top': scope.row.productName.toLowerCase() != 'whatsapp conversation' ? '65px': '110px'}"><span ></span></el-col>
                                                            <!-- <el-col v-else :style="{'padding-top': scope.row.additional_billing || scope.row.omni_billing || scope.row.productName.toLowerCase() != 'whatsapp conversation' ? '65px': '110px'}"><span ></span></el-col> -->
                                                            <el-col v-if="!scope.row.additional_billing && !scope.row.omni_billing" class="pd-item" :span="24"><span>Service Fee ({{scope.row.service_fee_type ? scope.row.service_fee_type.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()):''}})</span></el-col>
                                                            <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            <el-col v-if="!scope.row.additional_billing" :span="24">
                                                                <span><b>PPN</b></span>
                                                            </el-col>
                                                            <el-col :span="24">
                                                                <span><b>TOTAL</b></span>
                                                            </el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                label="Type"
                                                width="100">
                                                <template slot-scope="scope">
                                                        <el-row>
                                                            <!-- <el-col :span="24">
                                                                <div  class="wa-number" style="visibility: hidden;"><b>{{scope.row.list}}.</b> Whatsapp Business ({{scope.row.customerNumber}})</div>
                                                            </el-col> -->
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing" >Subscribe</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'">CBP</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'" >BI</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'" >UI</span></el-col>
                                                            <el-col class="mt-20" :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            <el-col v-if="scope.row.international_billing && scope.row.international_billing.length > 0" style="padding-top: 25px;" :span="24"><span></span>
                                                                <el-row v-for="(data, i) in scope.row.international_billing" :key="i">
                                                                    <el-col style="padding: 5px 0 5px 0;">
                                                                        <div>INT-BI</div>
                                                                        <div>INT-UI</div>
                                                                    </el-col>
                                                                </el-row>
                                                            </el-col>
                                                            <el-col v-else><span></span></el-col>
                                                            <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                label="Unpaid Quota"
                                                width="150"
                                                align="center">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <!-- <el-col :span="24">
                                                                <div  class="wa-number" style="visibility: hidden;"><b>{{scope.row.list}}.</b> Whatsapp Business ({{scope.row.customerNumber}})</div>
                                                            </el-col> -->
                                                            <el-col :span="24"><span style="visibility: hidden;">{{scope.row.subscribe || 0}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'">{{scope.row.cbp_unpaid || 0}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'" >{{scope.row.bi_unpaid || 0}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'" >{{scope.row.ui_unpaid || 0}}</span></el-col>
                                                            <el-col class="mt-20" :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            <el-col v-if="scope.row.international_billing && scope.row.international_billing.length > 0" style="padding-top: 25px;" :span="24"><span></span>
                                                                <el-row v-for="(data, i) in scope.row.international_billing" :key="i">
                                                                    <el-col style="padding: 0px 0 10px 0;">
                                                                        <div>{{data.bi_unpaid || 0}}</div>
                                                                        <div>{{data.ui_unpaid || 0}}</div>
                                                                    </el-col>
                                                                </el-row>
                                                            </el-col>
                                                            <el-col v-else><span></span></el-col>
                                                            <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                label="Sub Total"
                                                width="150"
                                                >
                                                <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :style="{'padding': scope.row.additional_billing || scope.row.omni_billing ? '20px 0 0 0': '35px 0 35px 0'}" :span="24">
                                                                <span v-if="!scope.row.additional_billing && !scope.row.omni_billing">
                                                                    <div style="visibility: hidden;"></div>
                                                                </span>
                                                                <span v-else>
                                                                    <span v-if="scope.row.additional_billing">
                                                                        <div style="color: #FF0000;" v-for="(item,idx) in scope.row.additional_sub_total" :key="idx">
                                                                            {{'- '+ convertToRupiah(Number(scope.row.additional_sub_total[idx]) || 0)}}
                                                                        </div>
                                                                    </span>
                                                                    <span v-if="scope.row.omni_billing">
                                                                        <div v-for="(item,idx) in scope.row.subscribe" :key="idx">
                                                                            {{convertToRupiah(Number(scope.row.subscribe[idx]) || 0)}}
                                                                        </div>
                                                                    </span>
                                                                </span>
                                                            </el-col>
                                                            <el-col :span="24"><span v-if="scope.row.omni_billing"><div v-for="(item,idx) in scope.row.serviceFeeTotal" :key="idx">
                                                                {{convertToRupiah(Number(scope.row.serviceFeeTotal[idx]) || 0)}}
                                                            </div></span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing" >{{convertToRupiah(Number(scope.row.subscribe) || 0)}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'">{{convertToRupiah(Number(scope.row.cbp_sub_total) || 0)}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'">{{convertToRupiah(Number(scope.row.bi_sub_total) || 0)}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing && scope.row.productName.toLowerCase() == 'whatsapp conversation'">{{convertToRupiah(Number(scope.row.ui_sub_total) || 0)}}</span></el-col>
                                                            <el-col class="mt-20" :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            <el-col v-if="scope.row.international_billing && scope.row.international_billing.length > 0" style="padding-top: 21px;" :span="24"><span></span>
                                                                <el-row v-for="(data, i) in scope.row.international_billing" :key="i">
                                                                    <el-col style="padding: 0px 0 10px 0;">
                                                                        <div>{{convertToRupiah(Number(data.bi_sub_total) || 0)}}</div>
                                                                        <div>{{convertToRupiah(Number(data.ui_sub_total) || 0)}}</div>
                                                                    </el-col>
                                                                </el-row>
                                                            </el-col>
                                                            <el-col v-else><span></span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing && !scope.row.omni_billing">{{convertToRupiah(Number(scope.row.service_fee_sub_total) || 0)}}</span></el-col>
                                                            <el-col :span="24"><span v-if="!scope.row.additional_billing">{{convertToRupiah(Number(scope.row.tax_sub_total) || 0)}}</span></el-col>
                                                            <!-- <el-col :span="24"><span v-if="scope.row.omni_billing">{{convertToRupiah(Number(scope.row.ppn/100 * scope.row.total_list) || 0)}}</span></el-col> -->
                                                            <el-col :span="24"><span :style="{'color': scope.row.additional_billing ? '#FF0000': 'inherit'}"><b>{{scope.row.additional_billing ? '- '+ convertToRupiah(Number(scope.row.total_list)||0) : convertToRupiah(Number(scope.row.total_list)||0)}}</b></span></el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <!-- <div style="display:flex; justify-content: space-between;"> -->
                                                <el-row>
                                                    <el-col style="padding-left: 0.5em;" :xs="8" :sm="8" :md="10" :lg="10" :xl="8">
                                                        <h2>Grand Total</h2>
                                                    </el-col>
                                                    <el-col style="padding-left: 8em;" :xs="16" :sm="16" :md="14" :lg="14" :xl="16">
                                                        <h2>{{countAllList()}}</h2>
                                                    </el-col>
                                                </el-row>
                                                
                                                
                                            <!-- </div> -->
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col style="text-align: center;" :span="24">
                                            <el-button style="margin: 5px 0 5px 0; background-color: #7E7BF2; color: #FFFFFF; padding-left: 50px; padding-right:50px;" @click="print" :loading="loadingPrint" round ><b>Print PDF</b></el-button>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="Additional" name="additional">
                        <el-row>
                            <el-col :span="24">
                                <div>
                                    <h1>Additional Billing</h1>
                                </div>
                                <div>
                                    <el-select @change="changeMonthAdditional" v-model="selectedMonth2" placeholder="Select Month" style="float:left; margin: 5px 10px 5px 0;">
                                        <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.disabled">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-button type="info" @click="getAdditionalBill" style="float:left; margin: 5px 0 5px 0;" :loading="btnLoading" round>Search</el-button>
                                    <el-button v-if="btnSave" style="float:right; margin: 5px 0 5px 0; background-color: #32C3F1;" @click="saveAdditionalBill" :loading="btnLoadingSave" round>Save Info Additional Billing</el-button>
                                </div>
                            </el-col>
                            <!-- <el-col style="text-align: right;" :span="12">
                                
                            </el-col> -->
                        </el-row>
                        <el-row style="margin-top: 20px; border-top: 1px solid #ebeef5; border-bottom: 1px solid #ebeef5;">
                            <el-col>
                                <el-row>
                                    <el-col>
                                        <h4>DAMCORP : Tactical Program</h4>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-form label-position="top">
                                            <el-form-item label-width="120px">
                                                <el-row style="margin-top: 10px;" :gutter="10" v-for="(item, i) in additional" :key="i">
                                                    <el-col v-if="additional.length > 1" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                                                        <span v-if="i == 0" style="visibility: hidden;">button</span>
                                                        <div style="text-align:center;">
                                                            <el-button :disabled="!btnSave" @click="removeTagProg(i)" type="danger" size="small"><i class="mdi mdi-close"/></el-button>
                                                        </div>
                                                    </el-col>
                                                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                        <span v-if="i == 0">Note</span>
                                                        <el-input :readonly="!btnSave" placeholder="Insert Note" v-model="item.note" ></el-input>
                                                    </el-col>
                                                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                                                        <span v-if="i == 0">Type</span>
                                                        <el-select
                                                        :disabled="!btnSave"
                                                        filterable
                                                        v-model="item.type" placeholder="Select Type" style="width:100%;" >
                                                            <el-option
                                                                v-for="item in optionType"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value">
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                                                        <span v-if="i == 0">Value</span>
                                                        <el-input :readonly="!btnSave" @keypress.native="numberOnly"  @paste.native="paste($event, i, 'value')" placeholder="Insert Value (Rp.)" v-model="item.value" ></el-input>
                                                    </el-col>
                                                </el-row>
                                                <el-row v-if="btnSave" style="margin-top: 20px;">
                                                    <el-col>
                                                        <el-button @click="addTacProg" style="width: 100%;">Add Tactical Program</el-button>
                                                    </el-col>
                                                </el-row>
                                            </el-form-item>
                                        </el-form>
                                    </el-col>
                                </el-row>
                                
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
                
                <!-- <el-button class="ml-10" @click="clear" style="float:left">Reset</el-button> -->
            </div>
        </div>
        <el-alert title="Info" type="info" description="No Data" show-icon v-if="showAlert"></el-alert>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
import jsPDF from "jspdf";


export default {
    props: {
        customerName: {
            type: String
        },
        billing: {
            type: Array,
        },
        totalBilling:{
            type: Number
        },
        showAlert: {
            type: Boolean
        },
        loadingInvoice: {
            type: Boolean
        },
        number:{
            type: Array
        }
    },
    data(){
        return {
            btnSave: true,
            srcPdf:"",
            pickerOptions: {
				disabledDate: this.disabledDate
			},
            tabs: 'report',
            today: moment().format("dddd, DD MMM YYYY"),
            getToday: moment().format('DD MMM YYYY'),
            getMonth: moment().month()+1,
            selectedMonth: moment().format("YYYY-MM"),
            selectedMonth2: moment().format("YYYY-MM"),
            btnLoading: false,
            btnLoadingDownload: false,
            btnLoadingSave: false,
            table: this.billing || [],
            loadingInv: false,
            loadingPrint: false,
            dataTotalBilling:this.totalBilling,
            dataNumber: this.number,
            consumen_name: this.customerName,
            options: [],
            options2: [],
            optionType:[{
                value: 'promotion',
                label: 'Promotion'
                }, {
                value: 'compensation',
                label: 'Compensation'}],
            additional: [{note: '', type: '', value: ''}]
        }
    },
    methods: {
        changeMonthAdditional(ev){
            // console.log(this.selectedMonth2);
            let today = moment()
            let someday = moment(this.selectedMonth2)
            let diff = today.diff(someday, 'month');

            if (diff > 0) {
                this.additional = [{note: '', type: '', value: ''}]
                this.btnSave = false
            }
            else{
                this.btnSave = true
            }
            
        },
        addTacProg() {
            this.additional.push({note: '', type: '', value: ''})
        },
        removeTagProg(i){
            this.additional.splice(i,1)
        },
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }
			if (field == 'value') {
				this.additional[index][field] = FilteredChars
			}
        },
        async print(){
            this.loadingPrint = true
            let elementHTML = document.getElementById('html-2-pdfwrapper')
            this.$html2canvas(elementHTML, {ignoreElements: function (el) {return el.tagName.toLowerCase() === 'button'},
            scale: 1.2})
            .then(canvas => {
                    var pdf = new jsPDF('p', 'pt', 'letter');

                    var pageHeight = 1200;
                    var pageWidth = 950;
                    for (var i = 0; i <= elementHTML.clientHeight / pageHeight; i++) {
                        var srcImg = canvas;
                        var sX = 0;
                        var sY = pageHeight * i; // start 1 pageHeight down for every new page
                        var sWidth = pageWidth;
                        var sHeight = pageHeight;
                        var dX = 0;
                        var dY = 0;
                        var dWidth = pageWidth;
                        var dHeight = pageHeight;

                        window.onePageCanvas = document.createElement("canvas");
                        onePageCanvas.setAttribute('width', pageWidth);
                        onePageCanvas.setAttribute('height', pageHeight);
                        var ctx = onePageCanvas.getContext('2d');
                        ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

                        var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);
                        var width = onePageCanvas.width;
                        var height = onePageCanvas.clientHeight;

                        if (i == 0) {
                            pdf.text(`${this.consumen_name}`, 30, 60)
                            pdf.text(`${moment(this.selectedMonth).format("MMM YYYY")}`, 400, 60)
                        }

                        if (i > 0) {pdf.addPage(612, 864)} // 8.5" x 12" in pts (inches*72)

                        pdf.setPage(i + 1); // now we declare that we're working on that page
                        pdf.addImage(canvasDataURL, 'PNG', 20, 70, (width * .62), (height * .62)); // add content to the page
                    }

                    pdf.autoPrint();

                    const hiddFrame = document.createElement('iframe');
                        hiddFrame.style.position = 'fixed';
                        // "visibility: hidden" would trigger safety rules in some browsers like safari，
                        // in which the iframe display in a pretty small size instead of hidden.
                        hiddFrame.style.width = '1px';
                        hiddFrame.style.height = '1px';
                        hiddFrame.style.opacity = '0.01';
                        const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
                        if (isSafari) {
                            // fallback in safari
                            hiddFrame.onload = () => {
                                try {
                                hiddFrame.contentWindow.document.execCommand('print', false, null);
                                } catch (e) {
                                hiddFrame.contentWindow.print();
                                }
                            };
                        }
                        hiddFrame.src = pdf.output('bloburl');
                    document.body.appendChild(hiddFrame);
                    // Save the PDF
                    // pdf.save('document.pdf');   //or whatever you want to execute
                    
                    this.loadingPrint = false
                });
        },
        convertToRupiah(num)
		{
            let angka = Math.ceil(num)
            let rupiah = '';		
            var angkarev = angka.toString().split('').reverse().join('');
            // for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
            let convert = angkarev.match(/\d{1,3}/g);   
            
            convert = convert.map((el,i) => {
                if (i < convert.length - 1 ) {
                    if (el.length < 3) {
                        el += ','
                    }
                    else {
                        el += '.'
                    }
                }
                return el
            })

            console.log('convert',convert);
            rupiah = 'Rp ' + convert.join('').split('').reverse().join('')

            return rupiah
		},
		convertToAngka(num)
		{
            let rupiah = num
			if (rupiah.includes("Rp. ")) {
				return parseInt(rupiah.replace(/,.*|[^0-9]/g, ''), 10);
			}
			else {
				return rupiah
			}
			
		},
        countPerList(data){
            let sub = {...data}

            let totalList = 0

            totalList =  Number(data.subscribe) + (Number(data.cbp_sub_total) || 0) + (Number(data.bi_sub_total) || 0) + (Number(data.ui_sub_total) || 0) + (Number(data.international_sub_total) || 0) + Number(data.service_fee_sub_total) + (Number(data.tax_sub_total) || 0)

            if (data.additional_billing){
                totalList = 0
                for (const property in data.additional_sub_total) {
                    totalList += (Number(data.additional_sub_total[property]) ? Number(data.additional_sub_total[property]) : 0)
                }
            }

            if (data.omni_billing){
                let totalSubscribe = 0
                let totalService = 0
                totalList = 0
                for (const property in data.subscribe) {
                    totalSubscribe += (Number(data.subscribe[property]) ? Number(data.subscribe[property]) : 0)
                }

                for (const property in data.serviceFeeTotal) {

                    if (data.serviceFeeType[property] == 'currency') {
                        totalService += (Number(data.serviceFeeTotal[property]) ? Number(data.serviceFeeTotal[property]) : 0)
                    }
                    else{
                        totalService += (Number(data.serviceFeeTotal[property]) ? Number(data.serviceFeeTotal[property]/100 * (data.subscribe[property] || 0)) : 0)
                    }
                }

                totalList = totalSubscribe + totalService
                console.log('totalList', totalList);
            }

            return totalList

        },
        countAllList(){
            let total = 0
            if (this.table.length > 0) {
                this.table.forEach(el => {
                    if (el.additional_billing) {
                        total -= (el.total_list || 0)
                    }
                    else {
                        total += (el.total_list || 0)
                    }
                })
            }
            return this.convertToRupiah(total)

        },
        disabledDate(date) {
			// console.log('date disable', date);
			var today = moment(), diff = today.diff(moment(date), 'd')
						if(moment(date) < moment('2022-02')|| diff < 0){
							return true
						} else {
							if(diff == 0){
								if(today.isSame(moment(date), 'd') == false){
									return true
								} else {
									return false
								}
							}
							return false
						}
			// return new Date() < date
		},
        async tabClick(targetName){
            switch (targetName.name) {
                case 'report':
                    await this.getBilling()
                    break;
                case 'additional':
                    await this.getAdditionalBill()
                    break;
            
                
            }
		},
        // print() {
		// 	window.print()
        // },
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
        },
        async changeFilter(){
			await this.getBilling()
        },
        async getBilling(query = ""){
            
            this.btnLoading = true

            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/get_new_billing",
                method: 'post',
                data:{
                    months: this.selectedMonth
                },
                timeout: (10 * 60) * 1000
            }
            if(query == "download"){
				apiOptions.responseType = "arraybuffer"
                apiOptions.params = {
					download: true,
				}
                this.btnLoadingDownload = true
            }
            else{
                this.table = []
            }
            
            await api(
                apiOptions
            )
            .then(res => {
                console.log('billing', res);
                // this.table = []
                if (res.data.ec == 200) {
                    
                        this.table = res.data.data

                        if (this.table.length > 0) {
                            this.table = this.table.map((el,n) => {
                                    el.list = String.fromCharCode(97 + n).toUpperCase()
                                    // el.productType = el.productType ? el.productType.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-'
                                    if (!el.additional_billing && !el.omni_billing) {
                                        if ( el.productName && el.productName.toLowerCase() == 'whatsapp conversation') {
                                            el.cbp_usage = el.cbp_usage || 0
                                            el.bi_usage = el.bi_usage || 0
                                            el.ui_usage = el.ui_usage || 0
                                            el.international_usage = el.international_usage || 0
        
                                            switch (el.productType) {
                                                case 'notification':
                                                    el.productType = 'CBP Invoice'
                                                    break;
                                                case 'notification_caping':
                                                    el.productType = 'CBP Caping'
        
                                                    break;
                                                case 'notification_caping_plafon':
                                                    el.productType = 'CBP Hybrid'
        
                                                    if (el.prepaid == 'true') {
                                                        el.productType += ' - Bundle'
                                                    }
                                                    else{
                                                        el.productType += ' - Plafon'
                                                    }
                                                    break;
                                            }
        
                                            
                                        }
                                        else {
                                            el.productType = el.productType ? el.productType.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-'
                                        }
                                    }

                                    el.total_list = this.countPerList(el)

                                    if (el.omni_billing) {
                                        el.sub_total_omni = this.countPerList(el)
                                        el.tax_sub_total = el.ppn/100 * el.sub_total_omni
                                        el.total_list = el.sub_total_omni + el.tax_sub_total
                                    }

                                    

                                    return el
                                })

                                console.log('table',this.table);
                        }
                }
                else if(query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
                            const url = window.URL.createObjectURL(new Blob([res.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', `Report Billing (${this.customerName || ''}).xlsx`); //or any other extension
                            link.click();
                        } catch(err){
                            console.log(err)
                        }
                    } else{
                        this.$swal(this.$t('error'), `${res.data.message}`, "error")
                    }
                }

                this.btnLoadingDownload = false
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingInv = false
                this.btnLoadingDownload = false
            })
        },
        async getAdditionalBill(query = ""){
            this.additional = [{note: '', type: '', value: ''}]
            this.btnLoading = true
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/get_additional_billing",
                method: 'post',
                data:{
                    months: this.selectedMonth2
                },
                timeout: (10 * 60) * 1000
            }
            // if(query == "download"){
            //     apiOptions.url += "?download"
            //     apiOptions.responseType = 'blob'
            // }
            await api(
                apiOptions
            )
            .then(res => {
                console.log('additional billing', res);
                if (res.data.ec == 200) {
                    this.additional = res.data.data.additional_billing.length > 0 ? res.data.data.additional_billing: this.additional
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingInv = false
            })
            this.btnLoading = false
            this.loadingInv = false
        },
        async saveAdditionalBill(){
            // this.btnLoadingSave = true

            // // console.log("selected month is",this.selectedMonth)
            // this.loadingInv = true
            let checkField = false
            this.additional.forEach((v, index, arr) => {
                if (v.note.trim() == '' || v.type.trim() == '' || v.value.trim() == '') {
                    checkField = true
                    arr.length = index + 1; // Behaves like `break`
                }
            })

            if (checkField) {
                this.$message({
                        type: 'error',
                        message: 'All field is required.'
                    });
                return
            }

            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/add_additional_billing",
                method: 'post',
                data:{
                    months: this.selectedMonth2,
                    data: this.additional
                },
                timeout: (10 * 60) * 1000
            }

            this.$confirm('Are you sure want to add this additional billing?', 'Warning', {
			confirmButtonText: 'OK',
			cancelButtonText: 'Cancel',
			type: 'warning',
			center: true
			}).then(() => {
				this.btnLoadingSave = true
                this.loadingInv = true
				api(apiOptions).then(res => {
					if(res.data.ec != 200){
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.btnLoadingSave = false
                        this.loadingInv = false
					} else {
						this.$message({
							type: 'success',
							message: 'Additional Billing has been added.'
						});
						// this.clear()
						this.btnLoadingSave = false
                        this.loadingInv = false
						this.getAdditionalBill()
					}
				}).catch(err => {
					console.log("Error",err)
                    this.btnLoadingSave = false
                    this.loadingInv = false
				})
				
			}).catch(() => {
                this.btnLoadingSave = false
                this.loadingInv = false
				this.$message({
					type: 'info',
					message: 'Delete canceled'
				});
			});
            
        },
        clear(){
            this.selectedMonth = ''
            // this.selectedMonth2 = ''
            // this.additional = [{note: '', type: '', value: ''}]
            this.getBilling()
        }
    },
    async beforeMount(){

        let d = new Date(2022,2);
        d.setDate(d.getDate()-1);
        
		for(let i = 6; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
            let data = {
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}

            if (data.value <  moment(d).format("YYYY-MM")) {
                data.disabled = true
            }

			this.options.push(data)
            this.options2.push(data)
		}
	},
    watch:{
        customerName: function() {
            this.consumen_name = this.customerName
        },
        billing: function() {
            this.table = this.billing
            if (this.table.length > 0) {
                this.table.forEach(el => {
                    el.total_list = this.countPerList(el)
                })
            }
            this.selectedMonth = moment().format("YYYY-MM")
        },
        totalBilling: function() {
            this.dataTotalBilling = this.totalBilling
        },
        number: function() {
            this.dataNumber = this.number
        },
        loadingInvoice: function() {
            this.loadingInv = this.loadingInvoice
        }
    }
}
</script>
<style>
.pd-item{
    padding-left: 17px;
}

/* .el-table thead {
    color: #000;
}
.el-table {
    color: #000;
} */

.el-table::before {
    content: none;
}
.header-text{
	font-weight: 700;
	color: #000;
	opacity: 0.7;
}

.page-invoice .invoice {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    max-width: 100% !important;
}
</style>

